import { inject, observer } from 'mobx-react';
import API from '@/services';
import React from 'react';

import { isNum, getTrans, getChildInject, replaceParams } from '@/utils/instantLoaded/tools';
import { formatPrice } from '@/utils/tools';
import dateLib from '@/utils/dateLib/moment';
import { handleRequest } from '@/utils';
import { addDialogue } from '@/utils/sessionUtils';
import { ListLoader, DescLoader } from '@/components/Common/Loader';
import { cdnFile } from '@/utils/cdnFile';

import NoResult from './NoResult';
import {
  TOTAL_PAYMENT_TEXT,
  ITEMS_TEXT,
  ITEM_TEXT,
  SELECT_ORDER_TEXT,
  NO_ORDERS_YET_TEXT,
  NO_ORDER_PLACEHOLDER_TEXT,
  ORDER_STH_WENT_WRONG_TEXT,
  ORDER_LOADING_TEXT,
  NO_MORE_BUTTON,
  LOAD_STH_WENT_WRONG_TEXT,
  TRACKING_TYPE,
  INPUT_TYPE,
  SELECT_RR_TEXT,
  REFUND_AMOUNT_TEXT,
  TRACKING_MSG_TYPE,
  ORDER_ID_TRANSIFY_KEY,
  GetMsgResCode,
  ALL_TEXT,
  TO_PAY_TEXT,
  TO_RECEIVE_TEXT,
  UNPAID_TEXT,
  TO_SHIP_TEXT,
  SHIPPING_TEXT,
  COMPLETED_TEXT,
  CANCELLED_TEXT,
  SELLER_CANCELLED_TEXT,
  SEARCH_ORDER_INFO_TEXT,
  TRACKING_SECTION,
  TRACKING_OPERATION,
  TRACKING_TARGET,
  OrderCardType,
} from '@/utils/constants';
import { tracker, dispatchTrack } from '@/utils/tracking';
import { USER_SEND_TYPE } from '@/types/history';
import { handleOrderRedirect } from '@/utils/btnClickHandler';

import ImgIC from '@/assets/img/ic_guarantee@2x.png';
import ImgNone from '@/assets/img/order_none@2x.png';
import ImgShop from '@/assets/img/shop_icon@2x.png';
import ImgWrong from '@/assets/img/something_wrong@2x.png';
import ImgNoOrder from '@/assets/img/no_order@2x.png';

import Vlist from '@/components/Common/Vlist';
import { COUNTRY } from '@/utils/locale';

import { postChatMsg, reviewChatEndText, addUserMsg } from '@/utils/agent';
import { ProductCardNew } from '@shopee/chatbot-ui/rn';
import { isDisableDisplayWithNewFlow } from '../../utils/experiment/getLiveAgentDisplayLogic';

import './style.scss';

export const orderListTypeToText = {
  0: ALL_TEXT,
  1: TO_PAY_TEXT,
  2: TO_SHIP_TEXT,
  3: TO_RECEIVE_TEXT,
  4: COMPLETED_TEXT,
  5: CANCELLED_TEXT,
  6: UNPAID_TEXT,
  7: TO_SHIP_TEXT,
  8: SHIPPING_TEXT,
  9: COMPLETED_TEXT,
  10: SELLER_CANCELLED_TEXT,
};

@tracker
@inject(getChildInject('modalStore', 'userStore', 'initStore', 'sessionStore', 'agentStore'))
@observer
class ProductList extends React.PureComponent {
  static defaultProps = {
    name: '',
    type: '',
    disabled: false,
    isForRR: false,
    // stores
    modalStore: {},
    userStore: {},
    initStore: {},
    subtabName: '',
  };
  productRef = React.createRef('');
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      // 正在加载中
      loading: false,
      isError: false,
      keyword: '',
    };

    this.startIndex = 0;
    this.limit = 5;
    // 是否需要加载更多数据
    this.loadMore = true;

    this.trackingname = TRACKING_TYPE.PANELORDER;

    this.trackingnameForOrderDetails = TRACKING_TYPE.MY_ORDER_LIST_ORDER_DETAILS;

    this.trackingnameForSelectOrder = TRACKING_TYPE.MY_ORDER_LIST_SELECT_ORDER;

    this.trackingnameForOrder = TRACKING_TYPE.MY_ORDER_LIST_ORDER;

    this.trackingnameForResult = TRACKING_SECTION.orderSelection;

    this.trackingnameForInboundSelectOrderBtn = TRACKING_TYPE.INBOUND_ORDER_SELECTOR;

    this.trackingData = {
      chat_session_id: this.props.initStore.sessionId || '0',
      chat_dialogue_id: this.props.modalStore.modalOrderList.dialogueId || '',
      origin: this.props.isSearching ? 'Search' : 'List',
      button_name: getTrans(NO_MORE_BUTTON),
    };

  }

  componentDidMount() {
    // addObserver(this.productRef.current);
    this.props.onRef && this.props.onRef(this);
    (!this.props.disabled && !this.props.isSearching) && this.loadMoreCb();
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.isSearching && (nextProps.keyword === this.props.keyword) && ((nextProps.isOnfocus !== this.props.isOnfocus) || (nextProps.inputValue !== this.props.inputValue))) { // 传入的count与组件当前props的count比较,count没改变，return false，不渲染
      return false;    // 不渲染
    }
    if (nextProps.keyword !== this.props.keyword) {
      this.setState({ data: [] });
      this.setState({ loading: true });
    }
    return true;
  }

  reset() {
    this.startIndex = 0;
    this.limit = 5;
    this.loadMore = true;
    this.props.tracker.impression.removeObserver();
  }

  UNSAFE_componentWillReceiveProps() {
    // tabs页切换时，重置列表页面
    this.setState({
      data: [],
      loading: false,
      isError: false,
    }, () => {
      this.reset();
      // !this.props.isSearching && this.loadMoreCb();
    });
  }

  useForbidOrderRedirect = () => {
    const forbidOrderRedirectCountries = ['co', 'cl'];
    const { isBuyer } = this.props;
    if (!isBuyer && forbidOrderRedirectCountries.includes(COUNTRY)) {
      return true;
    }

    return false;
  };

  // 下拉加载数据
  loadMoreCb = async () => {
    // 如果加载完全部数据或者正在加载，则跳过
    if (this.props.disabled || !this.loadMore || this.state.loading) {
      return;
    }
    const {
      isForRR,
      modalStore,
      agentStore,
      isBuyer,
      isInboundOrder,
    } = this.props;
    const { inAgent } = agentStore;
    const { is_seller } = modalStore.modalOrderList;
    const isSeller = (inAgent || isInboundOrder) ? !isBuyer : is_seller;
    this.setState({ loading: true });
    // 设置加载状态为正在加载
    this.setState({ loading: true }, async () => {
      let res;
      if (this.props.isSearching) {
        if (this.props.keyword) {
          res = await API.getSearchOrderList({
            page_num: this.startIndex,
            page_size: this.limit,
            is_seller: isSeller ? 1 : 0,
            key_word: this.props.keyword,
          }).catch(() => { });
        } else {
          res = { order_list: [] };
        }

      } else {
        res = isForRR
          ? await API.getReturnList({
            page_num: this.startIndex,
            page_size: this.limit,
            is_seller: isSeller ? 1 : 0,
          }).catch(() => { })
          : await API.getOrderList({
            query_type: this.props.type,
            page_num: this.startIndex,
            page_size: this.limit,
            is_seller: isSeller ? 1 : 0, // this.props.userStore.isSeller
          }).catch(() => { });
      }


      if (res) {
        const orderList = (isForRR ? (res || {}).return_list : (res || {}).order_list) || [];
        // 如果列表为空，则认为加载完成，同时设置加载状态为加载完
        if (orderList.length === 0) {
          this.loadMore = false;
          this.setState({ loading: false });
        } else {
          // 分页并设置单次加载完成
          this.startIndex = ++this.startIndex;
          this.setState({
            data: this.state.data.concat(orderList),
            loading: false,
          }, () => {
            this.props.tracker.impression.addObserver();
          });
        }
      } else {
        this.loadMore = false;
        this.setState({
          loading: false,
          isError: true,
        });
      }
    });
  };

  onClick = (order) => {
    const {
      type,
      name: typeName,
      isForRR,
      initStore,
      modalStore,
      sessionStore,
      agentStore,
    } = this.props;
    const sessionId = initStore.sessionId;
    const { node_id, dialogueId, dialogueType, isSelectOrder, customCallback = {}} = modalStore.modalOrderList;
    const orderStatusText = type === 0 ? getTrans(orderListTypeToText[order.order_list_type]) : typeName;

    const props = {};

    if (this.props.isSearching) {
      props.type_name = getTrans(orderListTypeToText[order.order_list_type]);
    } else {
      props.type_name = isForRR ? order.return_status : orderStatusText;
    }

    const item = order.items[0] || {};
    props.order_id = order.order_id;
    props.shop_id = order.shop_id;
    props.title = item.title;
    props.price = isForRR ? order.refund_amount : order.total_price;
    props.image = item.image[0] || '';
    props.specification = item.specification;
    props.order_sn = order.order_sn;
    props.item_count = order.item_count;
    props.checkout_id = order.checkout_id;
    props.return_id = order.return_id;
    props.uri_key = order.uri_key;
    props.items = order.items;
    props.item_count = order.item_count;
    props.item_amount = item.amount | 1;
    props.shouldRedirect = !this.useForbidOrderRedirect(),
    !this.useForbidOrderRedirect() && (props.handleClick = () => handleOrderRedirect(order));

    return (element) => {
      // 阻止冒泡
      element.stopPropagation?.();
      // 点击埋点
      this.trackingHandler(order);

      const trackingname = 'orderSelection';
      dispatchTrack({
        operation: TRACKING_OPERATION.CLICK,
        target: TRACKING_TARGET.button,
        section: TRACKING_SECTION[trackingname],
        data: {
          chat_session_id: this.props.initStore.sessionId || '0',
          chat_dialogue_id: dialogueId || '',
          origin: this.props.isSearching ? 'Search' : 'List',
          order_status_tab: type,
          button_name: getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT),
        },
      });

      const curPos = addDialogue({
        dialogueId: dialogueId,
        dialogueType: dialogueType,
        from: 'user',
        type: 'Order',
        data: { ...props },
      });

      if (isNum(curPos)) {
        // 非check RR status情况（无orderSN字段），记录展示的order的sn
        !isForRR && sessionStore.ADD_ORDER_SN(order.order_sn);
        delete props.handleClick;

        (order?.return_sn || order?.return_id) && sessionStore.SET_ORDER_INFO_DATA({
          return_sn: order?.return_sn,
          return_id: order?.return_id,
        });

        const params = {
          order_id: props?.order_id,
          return_id: order?.return_id,
          user_send: {
            type: USER_SEND_TYPE.ORDER_SELECT,
            order_select: {
              ...order,
              ...props,
              name: props.title,
              id: order?.order_id,
            },
          },
        };
        handleRequest('postMessage', {
          session_id: sessionId,
          dialogue_id: dialogueId,
          input_type: INPUT_TYPE.BUTTON,
          message_text: props.title,
          message_extra: {
            node_id,
            params: params || {},
          },
          ...customCallback,
        });
        modalStore.HIDE_ORDERLIST_MODAL();
      }
    };
  };

  onClickForAgent = (order) => {
    const {
      isForRR,
      type,
      name: typeName,
      initStore,
      modalStore,
      agentStore,
    } = this.props;
    const sessionId = initStore.sessionId;
    const { node_id, dialogueId, dialogueType } = modalStore.modalOrderList;
    const orderStatusText = type === 0 ? getTrans(orderListTypeToText[order.order_list_type]) : typeName;
    const props = {};
    const item = order.items[0] || {};
    props.order_id = order.order_id;
    props.shop_id = order.shop_id;
    props.title = item.title;
    props.price = isForRR ? order.refund_amount : order.total_price;
    props.image = item.image[0] || '';
    props.specification = item.specification;
    props.type_name = isForRR ? order.return_status : orderStatusText;
    props.order_sn = order.order_sn;
    props.checkout_id = order.checkout_id;
    props.return_id = order.return_id;
    props.uri_key = order.uri_key;
    props.item_count = order.item_count;
    props.item_amount = item.amount | 1;
    props.shouldRedirect = !this.useForbidOrderRedirect();
    !this.useForbidOrderRedirect() && (props.handleClick = () => handleOrderRedirect(order));
    props.order_list_type = order.order_list_type;

    return async (element) => {
      // 阻止冒泡
      element.stopPropagation();
      // 点击埋点
      this.trackingHandlerForAgent(order);

      const curPos = addUserMsg({
        from: 'user',
        type: 'Order',
        data: {
          ...props,
          loading: true,
        },
      });

      const params = {
        order_name: props.title,
        checkout_id: order.checkout_id,
        uri_key: order.uri_key,
        order_list_type: order.order_list_type,
        return_id: order.return_id,
        amount: item.amount | 1,
        ...props,
      };

      if (!isNum(curPos)) {
        return;
      }

      modalStore.HIDE_ORDERLIST_MODAL();

      if (agentStore.agentEndedReason) {
        // 回显agent离开文案
        reviewChatEndText();
        agentStore.UPDATE_AGENT_DATA_ITEM({
          loading: false,
          error: true,
          curPos,
        }, curPos);
      } else {
        const { code: resCode, data } = await postChatMsg({
          type: 'ORDER',
          params,
        });
        if (resCode === GetMsgResCode.SUCCESS) {
          agentStore.UPDATE_AGENT_DATA_ITEM({
            loading: false,
            error: false,
            messageId: data.message_id,
          }, curPos);
        } else {
          agentStore.UPDATE_AGENT_DATA_ITEM({
            loading: false,
            error: true,
            params,
            curPos,
          }, curPos);
        }
      }
    };
  };

  onClickForInbound = (order) => {
    const {
      type,
      name: typeName,
      isForRR,
      modalStore,
    } = this.props;
    const { dialogueId, dialogueType } = modalStore.modalOrderList;
    const orderStatusText = type === 0 ? getTrans(orderListTypeToText[order.order_list_type]) : typeName;

    const props = {};

    if (this.props.isSearching) {
      props.type_name = getTrans(orderListTypeToText[order.order_list_type]);
    } else {
      props.type_name = isForRR ? order.return_status : orderStatusText;
    }

    const item = order.items[0] || {};
    props.order_id = order.order_id;
    props.shop_id = order.shop_id;
    props.title = item.title;
    props.price = isForRR ? order.refund_amount : order.total_price;
    props.image = item.image[0] || '';
    props.specification = item.specification;
    props.order_sn = order.order_sn;
    props.item_count = order.item_count;
    props.checkout_id = order.checkout_id;
    props.return_id = order.return_id;
    props.uri_key = order.uri_key;
    props.items = order.items;
    props.item_count = order.item_count;
    props.item_amount = item.amount | 1;
    props.shouldRedirect = !this.useForbidOrderRedirect(),
    !this.useForbidOrderRedirect() && (props.handleClick = () => handleOrderRedirect(order));

    return (element) => {
      // 阻止冒泡
      element.stopPropagation?.();
      // 点击埋点
      this.trackingHandler(order);

      const trackingname = 'orderSelection';
      dispatchTrack({
        operation: TRACKING_OPERATION.CLICK,
        target: TRACKING_TARGET.button,
        section: TRACKING_SECTION[trackingname],
        data: {
          chat_session_id: this.props.initStore.sessionId || '0',
          chat_dialogue_id: dialogueId || '',
          origin: this.props.isSearching ? 'Search' : 'List',
          order_status_tab: type,
          button_name: getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT),
        },
      });

      dispatchTrack({
        operation: TRACKING_OPERATION.CLICK,
        target: TRACKING_TARGET[this.trackingnameForInboundSelectOrderBtn],
        section: TRACKING_SECTION[this.trackingnameForInboundSelectOrderBtn],
        data: {
          chat_session_id: this.props.initStore.sessionId || '0',
          button_name: getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT),
        },
      });

      this.props?.onSubmit({
        oderSn: order?.order_sn, dialogueParms: {
          dialogueId: dialogueId,
          dialogueType: dialogueType,
          from: 'user',
          type: 'Order',
          data: { ...props },
        },
      });
    };
  };

  handleOrderDetailRedirect = (order) => {
    const { tracker } = this.props;
    const { inAgent } = this.props.agentStore;
    if (inAgent) {
    // inAgent触发埋点 点击事件
      tracker.click({
        trackingname: this.trackingnameForOrderDetails,
        data: {
          orderid: order.order_id,
          order_status: getTrans(orderListTypeToText[order.order_list_type])?.toLocaleLowerCase(),
          ...this.props.trackingDataForAgent,
        },
      });
    }

    // 跳转页面
    !this.useForbidOrderRedirect() && handleOrderRedirect(order);
  };

  handleNoMoreOrder() {

    const nodeIdMap = {
      'RR_Check': 'SOP_4_NODE_B5',
      'RR_Raise': 'SOP_5_NODE_A3',
      'Order': 'SOP_1_NODE_B5',
    };

    const nodeSellerIdMap = {
      'RR_Check': 'SOP_4_NODE_B6',
      'Order': 'SOP_1_NODE_B6',
    };
    const nodeSearchIdMap = {
      'Order': 'SOP_1_NODE_B7',
      'RR_Check': 'SOP_4_NODE_B7',
      'RR_Raise': 'SOP_5_NODE_A4',
    };

    const {
      initStore,
      modalStore,
    } = this.props;
    const { node_id, dialogueId, dialogueType, is_seller, customCallback = {}} = modalStore.modalOrderList;

    const curPos = addDialogue({
      from: 'user',
      type: 'Msg',
      data: { content: getTrans(NO_MORE_BUTTON) },
    });

    const trackingname = 'orderSelection';
    dispatchTrack({
      operation: TRACKING_OPERATION.ACTION_SEAECH,
      target: TRACKING_TARGET.button,
      section: TRACKING_SECTION[trackingname],
      data: {
        chat_session_id: this.props.initStore.sessionId || '0',
        chat_dialogue_id: dialogueId || '',
        origin: 'List',
      },
    });

    let nodeId = '';
    if (is_seller) {
      nodeId = this.props.isSearching ? nodeSearchIdMap[dialogueType] : nodeSellerIdMap[dialogueType];
    } else {
      nodeId = this.props.isSearching ? nodeSearchIdMap[dialogueType] : nodeIdMap[dialogueType];
    }

    handleRequest(
      'postMessage',
      {
        session_id: initStore.sessionId,
        dialogue_id: dialogueId,
        input_type: 1,
        message_text: getTrans(NO_MORE_BUTTON),
        message_extra: { node_id: nodeId },
        ...customCallback,
      },

    );
    modalStore.HIDE_ORDERLIST_MODAL();
  }

  // 埋点用 - 点击事件
  trackingHandler = (order) => {
    const {
      type,
      initStore,
      modalStore,
      tracker,
      isForRR,
      isHistory,
      historyDialogueId,
      historySessionId,
    } = this.props;
    const { dialogueId, nodePointId, taskbotName } = modalStore.modalOrderList;


    tracker.click({
      trackingname: this.trackingname,
      data: {
        orderid: order.order_id,
        order_status: type,
        chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
        chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
        node_point_id: nodePointId,
        origin: this.state.isSearching ? 'Search' : 'List',
        button_type: order.button_type,
        button_id: order.button_id,
        button_text: getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT),
        task_bot_name: taskbotName,
        button_name: getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT),
        order_status_tab: type,
        if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      },
    });
  };

  trackingHandlerForAgent = (order) => {
    const { tracker } = this.props;

    tracker.click({
      trackingname: this.trackingnameForSelectOrder,
      data: {
        orderid: order.order_id,
        order_status: getTrans(orderListTypeToText[order.order_list_type]),
        ...this.props.trackingDataForAgent,
      },
    });
  };

  // render props，用于渲染列表项
  renderNode = (order, index) => {
    const {
      name: typeName,
      type,
      isForRR,
      initStore,
      modalStore,
      agentStore,
      passedRef,
      subtabName,
      isSearching,
    } = this.props;
    const {
      dialogueId,
      nodePointId,
      taskbotName,
      isHistory,
      historyDialogueId,
      historySessionId,
      is_seller,
      isSelectOrder,
      customSelectClick,
    } = modalStore.modalOrderList;

    const { inAgent, inNewFlowBeforeAgent } = agentStore;

    const { items = [], shop_image } = order;
    const item = items[0] || {};
    const shopImg = shop_image[0] && cdnFile(shop_image[0]) || ImgShop;
    const orderImg = item.image && item.image[0] || '';
    const itemText = order.item_count > 1 ? getTrans(ITEMS_TEXT) : getTrans(ITEM_TEXT);
    const orderStatusText = type === 0 ? getTrans(orderListTypeToText[order.order_list_type]) : typeName;

    const trackingdata = JSON.stringify({
      orderid: order.order_id,
      order_status: type,
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      button_type: order.button_type,
      button_id: order.button_id,
      origin: isSearching ? 'Search' : 'List',
      order_status_tab: subtabName || type,
      button_name: getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT) || '',
      button_text: getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT),
      task_bot_name: taskbotName,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    });

    const trackingDataForAgent = JSON.stringify({
      orderid: order.order_id,
      order_status: getTrans(orderListTypeToText[order.order_list_type]),
      ...this.props.trackingDataForAgent,
    });

    const handleButtonClick = (element) => {
      if (customSelectClick) {
        const transOrder = (order) => {
          const item = order.items[0] || {};

          return {
            ...order,
            title: item.title,
            image: item.image[0] || '',
            total_item_count: order.item_count,
            total_item_price: order.total_price,
            status: getTrans(orderListTypeToText[order.order_list_type]),
            order_sn: order.order_sn,
          };
        };

        addDialogue({
          dialogueId,
          from: 'user',
          type: 'Order',
          data: {
            ...transOrder(order),
            orderCardType: OrderCardType.newCarousel,
            shouldRedirect: !this.useForbidOrderRedirect(),
            handleClick: () => handleOrderRedirect(order),
          },
        });

        customSelectClick(order, index);
      } else {
        if (inAgent) {
          this.onClickForAgent(order)(element);
        } else if (this.props.isInboundOrder) {
          this.onClickForInbound(order)(element);
        } else {
          this.onClick(order)(element);
        }
      }
      modalStore.HIDE_ORDERLIST_MODAL();
    };

    return isDisableDisplayWithNewFlow() && inNewFlowBeforeAgent ? (
      <ProductCardNew
        totalPrice={formatPrice(isForRR ? order.refund_amount : order.total_price) }
        title={item.title}
        itemCount={item.amount}
        image={orderImg ? cdnFile(orderImg) : ImgNoOrder}
        orderTime={ dateLib.format(order?.create_time * 1000, 'DD MMM YYYY HH:ii')}
        orderStatusText={orderStatusText}
        orderTimeText={getTrans('label_order_time')}
        onButtonClick={handleButtonClick}
      />
    ) : (<div
      className="order-item"
      key={index}
      ref={(ele) => passedRef(ele, index)}
      data-trackingname={inAgent ? this.trackingnameForOrder : this.trackingname}
      data-trackingdata={inAgent ? trackingDataForAgent : trackingdata}
      data-trackingindex={`${type}${index}`}
      onClick={() => this.handleOrderDetailRedirect(order)}
    >
      <div className="order-shop">
        <span className="shop-name">
          <img src={shopImg} alt="shop" />
          <span>{order.shop_name}</span>
        </span>
        {
          this.props.isSearching
            ? <span className="type-name">
              {getTrans(orderListTypeToText[order.order_list_type]) }
            </span>
            : <span className="type-name">
              {isForRR ? order.return_status : orderStatusText }
            </span>
        }

      </div>
      <div className="order-content chatbot_order_content">
        <img className="chatbot_img" src={orderImg ? cdnFile(orderImg) : ImgNoOrder} alt="item" />
        <p className="item-title">{item.title}</p>
        <p className="item-spec chatbot_item_spec">
          <span className="item-desc">{item.specification}</span>
          <span className="item-account">x{item.amount}</span>
        </p>
        <p className="item-price chatbot_item_spec">{formatPrice(item.order_price)}</p>
      </div>
      <div className="order-amount">
        <span className="count">{order.item_count + ' ' + itemText}</span>
        <span className="price">
          <img className="money-icon" src={ImgIC} alt="money" />
          {getTrans(isForRR ? REFUND_AMOUNT_TEXT : TOTAL_PAYMENT_TEXT)}: <span>{formatPrice(isForRR ? order.refund_amount : order.total_price)}</span>
        </span>
      </div>
      {
        (is_seller || inAgent) && (
          <div className="order-sn">
            <span className="order-sn-title">
              {getTrans(ORDER_ID_TRANSIFY_KEY)}
            </span>
            <span className="order-sn-content">
              {order.order_sn}
            </span>
          </div>
        )
      }
      <div className="buttons chatbot_product_list_order_item_buttons" onClick={(element) => element.stopPropagation()}>
        <SelectOrderButton
          tracking={this.props.isInboundOrder ? {
            'data-trackingname': this.trackingnameForInboundSelectOrderBtn,
            'data-trackingdata': JSON.stringify({
              chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
              button_name: getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT),
            }),
            'data-trackingindex': `${type}-${order.order_sn}`,
          } : undefined}
          onClick={(element) => {
            if (inAgent) {
              this.onClickForAgent(order)(element);
            } else if (this.props.isInboundOrder) {
              this.onClickForInbound(order)(element);
            } else {
              this.onClick(order)(element);
            }
          }}
          content={getTrans(isForRR ? SELECT_RR_TEXT : SELECT_ORDER_TEXT)}
        />
      </div>
    </div>);
  };

  render() {
    const { loading, data, isError } = this.state;

    const { agentStore } = this.props;
    const { inAgent } = agentStore;

    let result = '';
    const $itemWrong = <div className="load-wrong">{getTrans(LOAD_STH_WENT_WRONG_TEXT)}</div>;
    const $itemLoading = <div className="item-loading">{getTrans(ORDER_LOADING_TEXT)}<DescLoader /></div>;

    const $searchOrderEmpty = <div className="order-empty">
      <img width="120" height="120" src={ImgNone} alt="empty" />
      {
        this.props.keyword
          ? <NoResult/>
          : <p>{getTrans(NO_ORDER_PLACEHOLDER_TEXT)}</p>
      }
    </div>;


    const $orderWrong = <div className="order-empty">
      {
        !this.state.keyword && this.props.isSearching
          ? <>
            {$searchOrderEmpty}
          </>
          : <>
            <img src={ImgWrong} alt="empty" />
            <p>{getTrans(ORDER_STH_WENT_WRONG_TEXT)}</p>
          </>

      }
    </div>;

    const $orderEmpty = <div className="order-empty">
      <img src={ImgNone} alt="empty" />
      <p>{getTrans(NO_ORDERS_YET_TEXT)}</p>
    </div>;

    const noMoreStyles = { height: '6.5rem' };
    const $orderLoading = <div className="order-loading">
      <ListLoader />
    </div>;

    const $loadFinish = <div style={!this.loadMore ? noMoreStyles : {}} className="load-wrong">
      <div className="no-more-button-wrap">
        {
          !this.loadMore && !(inAgent || this.props.isInboundOrder) && <div
            ref={this.productRef}
            data-trackingname={this.trackingnameForResult}
            data-trackingdata={ JSON.stringify({ ...this.trackingData })}
            onClick={() => { this.handleNoMoreOrder(); }}
            className="no-more-button" >
            {
              getTrans(NO_MORE_BUTTON)
            }
          </div>
        }
      </div>
    </div>;

    if (data.length > 0) {
      result = (
        <>
          {
            (this.props.isSearching && data.length)
          && <div className="search-result-info">
            {replaceParams(getTrans(SEARCH_ORDER_INFO_TEXT), { keywords: this.props.keyword })}
          </div>
          }
          <Vlist
            data={this.state.data}
            renderNode={this.renderNode}
            loadMore={this.loadMoreCb}>
            {
              () => {
                let result = $loadFinish;

                if (this.loadMore) {
                  result = loading ? $itemLoading : (isError ? ($itemWrong) : $loadFinish);
                }

                return result;
              }
            }
          </Vlist>

        </>);
    } else if (data.length === 0) {
      result = loading
        ? $orderLoading
        : (isError
          ? $orderWrong
          : (this.props.isSearching ? $searchOrderEmpty : $orderEmpty));
    }

    return (
      <>
        {result}
      </>);
  }
}

const SelectOrderButton = tracker((props) => {
  const tracking = props?.tracking ? {
    ...props.tracking,
    ref: props.passedRef,
  } : {};

  return (
    <button
      className="button"
      onClick={props.onClick}
      {...tracking}
    >
      {props.content}
    </button>
  );
});

export default ProductList;
